import { createFileRoute } from "@tanstack/react-router";
import QRCode from "react-qr-code";
import { VolumeApi } from "@/lib/volume-api";
import { Button } from "@/components/ui/button";
import { SmsForm } from "@/routes/(app)/_main-layout/_pay-by-link/-components/sms-form";
import { ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export const Route = createFileRoute(
  "/(app)/_main-layout/_pay-by-link/pay-by-link_/$paymentIntentId",
)({
  component: () => <Payment />,
  loader: async ({ params, context }) => {
    const api = new VolumeApi(
      context.accessToken,
      context.selectedApplicationId,
    );
    return api.getPaymentIntent({
      paymentIntentId: params.paymentIntentId,
    });
  },
});

function Payment() {
  const paymentIntent = Route.useLoaderData();
  const navigate = Route.useNavigate();

  return (
    <>
      <div
        className="flex px-3 py-1 mb-4 text-volume-text-purple hover:cursor-pointer hover:underline"
        onClick={() => {
          navigate({
            to: "/pay-by-link",
            search: (params) => ({ applicationId: params.applicationId }),
          });
        }}
      >
        <ArrowLeft color="#5C25A8" className="mr-2 " /> Back
      </div>
      <div className="w-full rounded-xl bg-white px-6">
        <div className="flex items-center">
          <h1 className="flex py-3 text-xl font-semibold">
            {paymentIntent.merchantPaymentId}{" "}
            {paymentIntent.paymentRequest.currency.toUpperCase()}{" "}
            {paymentIntent.paymentRequest.amount}
          </h1>
        </div>
        <div className="flex text-volume-dark-grey ">
          <div className="w-1/2 ">
            Description
            <div className="mt-2 text-gray-600">
              {paymentIntent.customerIntentDescription}
            </div>
          </div>
          <div>
            Note
            <div className="mt-2 text-gray-600">
              {paymentIntent.merchantIntentDescription}
            </div>
          </div>
        </div>
        <Divider />
        <div className="py-2">
          <div className="py-2 font-bold">Payment Link</div>
          <div className="py-2 text-volume-dark-grey">
            {paymentIntent.paymentIntentLink}
          </div>
          <div className="max-w-[200px] py-2">
            <Button
              onClick={() => {
                navigator.clipboard
                  .writeText(paymentIntent.paymentIntentLink)
                  .then(() => {
                    toast.success("Link copied to clipboard");
                  })
                  .catch((err) => {
                    console.error("Failed to copy link", err);
                    toast.error("There was an error copying the link");
                  });
              }}
            >
              Copy Link
            </Button>{" "}
          </div>
        </div>
        <Divider />
        <div className="py-2">
          <div className="py-2 font-bold">QR Code</div>
          <div className="py-2 text-volume-dark-grey">
            This QR code can be scanned by the customers phone. It will then
            redirect them to a payment confirmation page.
          </div>
          <div className="flex h-[200px] w-[200px] content-center items-center">
            {paymentIntent.paymentIntentLink && (
              <QRCode id="QRCode" value={paymentIntent.paymentIntentLink} />
            )}
          </div>
          <div className="max-w-[200px] py-2">
            <DownloadQrButton />
          </div>
        </div>
        <Divider />
        <div className="py-2">
          <div className="py-2 font-bold">Send via SMS</div>
          <div className="py-2 text-volume-dark-grey">
            The url will be sent as an SMS message to the phone number provided
            below.
          </div>
          <SmsForm />
        </div>
      </div>
    </>
  );
}

const Divider = () => (
  <div className="relative flex items-center py-1">
    <div className="grow border-t border-gray-300"></div>
    <div className="grow border-t border-gray-300"></div>
  </div>
);

function DownloadQrButton() {
  return <Button onClick={onDownloadQRCode}>Download QR</Button>;
}
const onDownloadQRCode = () => {
  const svg = document.querySelector("#QRCode");
  if (!svg) return;
  const svgData = new XMLSerializer().serializeToString(svg);
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) return;
  const img = new Image();
  img.addEventListener("load", () => {
    canvas.width = img.width;
    canvas.height = img.height;
    context.drawImage(img, 0, 0);
    const pngFile = canvas.toDataURL("image/png");
    const downloadLink = document.createElement("a");
    downloadLink.download = "QRCode";
    downloadLink.href = pngFile;
    downloadLink.click();
  });
  img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
};
